<template>
   <div class="multi-choice-item mb-3 cursor-pointer rounded-md bg-grey-10">
      <div class="multi-choice-item-bg flex w-full items-center">
         <input
            :id="`multi-choice-item-${id}`"
            :data-cy="`multi-choice-item-${id}`"
            type="checkbox"
            :name="`${props.name}-multi-choice`"
            :value="id"
            class="absolute left-0 z-1 ml-6"
            :checked="props.checked"
            :disabled="isDisabled"
            @change="onChange($event, { id, label })"
         />
         <label
            :for="`multi-choice-item-${id}`"
            class="multi-choice-item-label flex size-full cursor-pointer items-center rounded-md px-6 py-3"
         >
            <span class="pl-8">{{ label }}</span>
         </label>
      </div>
   </div>
</template>

<script setup lang="ts">
// props
// -----------------------------------------
interface Props {
   id: string;
   label: string;
   name: string;
   checked: boolean;
   isDisabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), { isDisabled: false });

const emit = defineEmits(["change"]);

// methods
// -----------------------------------------
function onChange($event, choice) {
   const choiceInfo = { newChoice: choice, isChecked: $event.target.checked };
   emit("change", choiceInfo);
}
</script>

<style scoped>
.multi-choice-item .multi-choice-item-bg input {
   accent-color: white;
}
.multi-choice-item .multi-choice-item-bg input:checked {
   background: var(--colour-brand-background);
   accent-color: white;
}
.multi-choice-item .multi-choice-item-bg input:checked + .multi-choice-item-label {
   background: var(--colour-brand-background);
   color: white;
}
</style>
